const DEFAULT_TUNNEL_NAME = 'default';

const CHECK_CHANNEL_STATE_INTERVAL_MS = 2000;
const MAX_TIME_TO_WAIT_FOR_CHANNEL_MS = 30000; // wait max 30sec (SLA) for the channel to be "in progress"
const MAX_TIME_TO_WAIT_FOR_SEND_MESSAGE_RESPONSE_MS = 1000 * 60 * 5; // after 5min reject any pending request

const MAX_RECONNECTION_TIMEOUT_MS = 1000 * 90; // try max 90sec to reconnect
const RECONNECTION_RETRY_INTITIAL_TIMEOUT_MS = 100; // start after 100ms to try to reconnect, will increase exponentially

const MESSAGE_NAMES_INCOMING = Object.freeze({
  ERROR: 'error',
  SCREENSHOT_RETRIEVED: 'screenshot_retrieved',
  SESSION_CLOSED: 'session_closed',
  SESSION_WILL_EXPIRE: 'session_will_expire',
  STATUS_RECEIVED: 'status_retrieved',
});

const MESSAGE_NAMES_OUTGOING = Object.freeze({
  CLOSE_SESSION: 'close_session',
  GET_STATUS: 'get_status',
  TAKE_SCREENSHOT: 'get_screenshot',
});

const SOCKET_STATES = Object.freeze({
  COMPLETE: 'complete',
  ERROR: 'error',
  IN_PROGRESS: 'in progress',
  NEW: 'new',
  QUEUED: 'queued',
});

const SESSION_CLOSED_ORIGINS = Object.freeze({
  CLIENT: 'client', // LSM due to a timeout
  SERVER: 'server', // Chef due to an internal error or due to a timeout
  USER: 'user', // a participant
} as const);

export default {
  CHECK_CHANNEL_STATE_INTERVAL_MS,
  DEFAULT_TUNNEL_NAME,
  MAX_RECONNECTION_TIMEOUT_MS,
  MAX_TIME_TO_WAIT_FOR_CHANNEL_MS,
  MAX_TIME_TO_WAIT_FOR_SEND_MESSAGE_RESPONSE_MS,
  MESSAGE_NAMES_INCOMING,
  MESSAGE_NAMES_OUTGOING,
  RECONNECTION_RETRY_INTITIAL_TIMEOUT_MS,
  SESSION_CLOSED_ORIGINS,
  SOCKET_STATES,
};
